/**
 * Dentrix Familiar wording. OWNER: the Dentrix skin agent.
 *
 * From the theme spec section 2.9 and NOTES-dentrix section 3 (exact labels
 * verified in Dentrix help text and screenshots [V]). Only the words that
 * differ from Velora's are listed; new keys go into ../terms.ts by request
 * (docs/themes/requests-dentrix.md). Module names are Dentrix's window names
 * ("Appointment Book", "Family File"); the word "Dentrix" itself never
 * appears (spec 7.5).
 */
import type { TermMap } from '../terms.js';

export const terms: TermMap = {
  /* Modules */
  schedule: 'Appointment Book',
  familyFile: 'Family File',
  patientFile: 'Family File',
  ledger: 'Ledger',
  chart: 'Patient Chart',
  perio: 'Perio Chart',
  txPlan: 'Treatment Planner',
  recall: 'Continuing Care',
  clinicalNotes: 'Clinical Notes',
  progressNotes: 'Progress Notes',
  checkout: 'Fast Checkout',
  reports: 'Office Manager',
  documents: 'Document Center',
  contactLog: 'Office Journal',
  communications: 'Send Message',
  /* People and records */
  selectPatient: 'Select Patient',
  guarantor: 'Guarantor',
  headOfHouse: 'Head of House',
  household: 'Family',
  chartNumber: 'Chart #',
  patientId: 'Chart #',
  operatory: 'Operatory',
  newPatient: 'New Patient',
  alerts: 'Patient Alerts',
  /* Scheduling */
  pinboard: 'Pinboard',
  unscheduledList: 'Unscheduled List',
  asapList: 'ASAP List',
  breakAppointment: 'Break Appointment',
  setComplete: 'Set Complete',
  routeSlip: 'Route Slip',
  dayNote: 'Day Note',
  huddle: 'Daily Huddle',
  statusArrived: 'HERE',
  statusSeated: 'READY',
  statusCheckout: 'Fast Checkout',
  /* Money */
  payment: 'Enter Payment',
  insurancePayment: 'Insurance Payment',
  adjustment: 'Enter Adjustment',
  writeoff: 'Write-Off Adjustment',
  statement: 'Billing Statement',
  claim: 'Dental Claim',
  paymentPlan: 'Payment Agreement',
  estInsurance: 'Est. Dental Ins. Portion',
  estPatient: 'Est. Patient Portion',
  daySheet: 'Day Sheet',
  /* Clinical */
  procedureButtons: 'Procedure Buttons',
  procedureCodes: 'Procedure Codes',
  txStatusPlanned: 'Treatment Plan',
  txStatusComplete: 'Completed',
  txStatusExisting: 'Existing',
  txStatusExistingOther: 'Existing Other',
  /* Menus (Alt access keys as in the product) */
  menuFile: '&File',
  menuEdit: '&Edit',
  menuView: '&View',
  menuModules: '&Modules',
  menuHelp: '&Help',
  menuVelora: 'V&elora',
};
